import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/accountTypeLogo.scss';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
import { AccountSeal, getAccountSealLocalizationKey } from '@shared/utils/cache/Accounts/Account.types';
import { Resources } from '@shared/localizations/Resources';
export const AccountTypeLogo = ({ accountType }) => {
    const accountModeClasses = {
        [AccountSeal.Demo]: 'demo',
        [AccountSeal.Live]: 'live',
        [AccountSeal.Contest]: 'contest',
        [AccountSeal.Funded]: 'funded',
        [AccountSeal.Challenge]: 'challenge',
        [AccountSeal.Unspecified]: 'demo'
    };
    const accountModeClassNames = ['account-type-logo', accountModeClasses[accountType]];
    const accountModeClassName = accountModeClassNames.filter(Boolean).join(' ');
    return (_jsx(Typography, { level: TypographyLevel.BodyXs, noWrap: true, className: accountModeClassName, children: Resources.getResource(getAccountSealLocalizationKey(accountType)) }));
};
